import React, { useState } from 'react'
import { InputRow, LabelDots, Loader, Popup, SortableTable, genericTexts, SplitButton } from 'hub-web-lib'
import { qaImplementationValues, qaMetricsCategories, qaMetricsKeys, qaMetricsWidgets, qaValueProps } from 'js/constants/metrics/qa-metrics'
import { qaMetricsColumnsForm } from 'js/constants/table-columns'
import QAApi from 'services/QAApi'
import store from 'js/store'
import { action } from 'js/actions'
import { UPDATE_NOTIFICATION_CONTENT } from 'js/constants/action-types'
import { connect } from 'react-redux'
import UserApi from 'services/UserApi'
import 'scss/UpdateActivity/MetricsTable.scss'
import { checkImportingErrors, getChangedMetrics, getMetricId, getMetricsConsts, getMetricsLabelDots, getRequiredFieldError, getTextFields, getValuesFields, preparePredefinedMetrics, refactorImportedMetrics } from 'js/ui-helpers/metrics'
import { downloadMetricsTemplateBtn, importMetricsBtn, calculateMetricsBtn } from 'js/constants/enums/common-activity'

const metricsColumnsCustom = [...qaMetricsColumnsForm]
metricsColumnsCustom[3].name = <span className='custom-th'>Value / Values</span>
const mapStateToProps = state => {
    return {
        currentUser: state.currentUser
    }
}

const metricsConsts = getMetricsConsts(
    qaMetricsCategories, 
    qaMetricsWidgets, 
    qaMetricsKeys, 
    qaImplementationValues
)

const labelDotsItems = getMetricsLabelDots(metricsConsts)
labelDotsItems[0].label = `${labelDotsItems[0].label} / Value`

const QAActivityMetricsComponent = ({ data, currentUser }) => {
    const currentOrgId = currentUser?.current_org
    const {
        activityToUpdate,
        newMetricModel,
        customMetrics,
        predefinedMetricsToEdit,
        updateMetrics,
        templateUrl,
        isReview
    } = data
    
    const [custom, setCustom] = useState(customMetrics)
    const [predefined, setPredefined] = useState(preparePredefinedMetrics(predefinedMetricsToEdit, metricsConsts))
    const [metricsFile, setMetricsFile] = useState(null)
    const [sheetName, setSheetName] = useState('')
    const [isOpenedMetricsPopUp, setIsOpenedMetricsPopUp] = useState(false)
    const [isOpenedSheetPopUp, setIsOpenedSheetPopUp] = useState(false)
    const [isImportingMetrics, setIsImportingMetrics] = useState(false)
    const [importingErrors, setImportingErrors] = useState([])
    const [isOpenedMetricsErrorsPopup, setIsOpenedMetricsErrorsPopup] = useState(false)
    const isQaWarningMessageDisabled = UserApi.getUserProp('isQaWarningMessageDisabled', currentUser?.id)
    const [isWarningDisabled, setIsWarningDisabled] = useState(JSON.parse(isQaWarningMessageDisabled))
    const [isButtonLoading, setIsButtonLoading] = useState(false)
    const [isOpenedCalculationConfirmationPopup, setIsOpenedCalculationConfirmationPopup] = useState(false)

    const changeFile = (file) => {
        setMetricsFile(file)
        setIsOpenedSheetPopUp(true)
        setIsOpenedMetricsPopUp(false)
        setIsOpenedMetricsErrorsPopup(false)
    }

    const importMetricsClick = () => {
        UserApi.setUserPropCookie('isQaWarningMessageDisabled', isWarningDisabled, currentUser?.id, true)
        const importMetricsRow = document.getElementById('fileUpload')
        importMetricsRow.click()

    }

    const calculateMetricsClick = () => {
        setIsOpenedCalculationConfirmationPopup(true)
        setIsOpenedMetricsErrorsPopup(false)
    }

    const checkIfCookiesExists = () => {
        isWarningDisabled ? importMetricsClick() : setIsOpenedMetricsPopUp(true)
    }

    const closeSheetPopUp = () => {
        setIsOpenedSheetPopUp(false)
        setSheetName('')
    }

    const uploadNewMetrics = async () => {
        if (!metricsFile) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: 'Please choose a file', notificationType: 'error' }))
            return
        }
        setIsImportingMetrics(true)
        setIsButtonLoading(true)
        const formData = new FormData()
        formData.append('file', metricsFile)
        const importedMetricsData = await QAApi.postMetricsFile(currentOrgId, formData, sheetName)
        if (!importedMetricsData || importedMetricsData.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: `Import failed: ${importedMetricsData.error}`, notificationType: 'error' }))
            setIsButtonLoading(false)
            setIsOpenedSheetPopUp(false)
            setIsImportingMetrics(false)
            return
        }
        const updatedMetrics = refactorImportedMetrics(importedMetricsData?.qa_metrics?.data_entities || [], qaValueProps)
        setPredefined(updatedMetrics)
        updateMetrics(updatedMetrics, true)
        checkImportingErrors(importedMetricsData?.qa_metrics, updatedMetrics, setImportingErrors, setIsOpenedMetricsErrorsPopup)
        setIsOpenedSheetPopUp(false)
        setIsButtonLoading(false)
        setIsImportingMetrics(false)
    }

    const calculateMetrics = async () => {
        setIsImportingMetrics(true)
        setIsButtonLoading(true)
        const calculatedMetricsData = await QAApi.calculateMetrics(currentOrgId, activityToUpdate.id)
        if (!calculatedMetricsData || calculatedMetricsData.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: `Calculation failed: ${calculatedMetricsData.error}`, notificationType: 'error' }))
            setIsOpenedCalculationConfirmationPopup(false)
            setIsButtonLoading(false)
            setIsImportingMetrics(false)
            return
        }
        const updatedMetrics = refactorImportedMetrics(calculatedMetricsData?.data_entities || [], qaValueProps)
        setPredefined(updatedMetrics)
        updateMetrics(updatedMetrics, true)
        setIsOpenedCalculationConfirmationPopup(false)
        setIsButtonLoading(false)
        setIsImportingMetrics(false)
    }

    const changeMetricValue = (key, i, val, isPredefined) => {
        let updatedMetrics = getMetrics(isPredefined)
        updatedMetrics = getChangedMetrics(updatedMetrics, key, i, val, metricsConsts)
        setMetrics(updatedMetrics, isPredefined)
        updateMetrics(updatedMetrics, isPredefined)
    }

    const addNewMetric = () => {
        const updatedMetrics = [...custom, { ...newMetricModel }]
        setCustom(updatedMetrics)
    }

    const deleteMetric = (index, isPredefined) => {
        const updatedMetrics = (getMetrics(isPredefined)).filter((_, i) => i !== index)
        setMetrics(updatedMetrics, isPredefined)
        updateMetrics(updatedMetrics, isPredefined)
    }

    const setMetrics = (updatedMetrics, isPredefined) => {
        isPredefined ? setPredefined(updatedMetrics) : setCustom(updatedMetrics)
    }

    const getMetrics = (isPredefined) => {
        return isPredefined ? [...predefined] : [...custom]
    }

    const checkRequiredField = (val, isPredefined, i) => {
        const metrics = getMetrics(isPredefined)
        return getRequiredFieldError(val, i, isPredefined, metrics.length) 
    }

    const metricsFunctions = {
        changeMetricValue,
        checkRequiredField,
        deleteMetric
    }

    const getMetricsTableData = (isPredefined) => {
        const metrics = getMetrics(isPredefined)
        const data = metrics.map((metric, i) => {
            const id = getMetricId(metric, i, isPredefined, predefined)
            const metricProps = {
                metric, 
                i,
                metricsLength: metrics.length,
                id, 
                isPredefined,
            }
            const valuesFields = getValuesFields(metricProps, metricsConsts, metricsFunctions)
            const textFields = getTextFields(metricProps, metricsConsts, metricsFunctions)
            return {
                id,
                ...metric,
                ...textFields,
                ...valuesFields
            }
        })
        return data
    }

    const customMetricsTableData = getMetricsTableData(false)
    const predefinedMetricsTableData = getMetricsTableData(true)

    const splitButtonsList = isReview ? [downloadMetricsTemplateBtn, importMetricsBtn, calculateMetricsBtn] : [downloadMetricsTemplateBtn, importMetricsBtn]

    const downloadTemplate = () => {
        if (templateUrl) {
            window.open(templateUrl, '_blank', 'noopener,noreferrer')
        } else {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: 'Template not found', notificationType: 'error' }))
        }
    }

    const handleSplitButtonClick = (val) => {
        switch (val) {
        case 1: {
            downloadTemplate()
            break
        }            
        case 3: {
            checkIfCookiesExists()
            break
        }
        case 5: {
            calculateMetricsClick()
            break
        }
        }
    }

    return (
        <div className='metrics-tables'>
            <div className='metrics-tables-header'>
                <div className='metrics-table-title'>
                    <h3 id='qa-activity-metrics'>Activity Metrics</h3>
                </div>
                <div className='metrics-tables-header-buttons'>
                    <SplitButton buttonsList={splitButtonsList} selectedButtonId={1} splitButtonId='lets-split' splitButtonClass='btn-set' handleButtonClick={handleSplitButtonClick} />
                </div>
            </div>
            <fieldset className='label-dot-fieldset'>
                <LabelDots list={labelDotsItems} />
            </fieldset>
            <fieldset className='editable-table metrics-tables-custom'>

                <SortableTable
                    columns={metricsColumnsCustom}
                    tableData={customMetricsTableData}
                    itemsPerPage={0}
                    noFilter={true}
                    tableId='qa-activity-metrics-custom-table' />
                <div className='editable-table-bottom'>
                    <button className='btn-link' onClick={addNewMetric} id='add-custom-metric'><i className='icon-plus'></i> Custom Metrics</button>
                </div>
            </fieldset>
            <fieldset className='editable-table metrics-tables-predefined'>
                {isImportingMetrics ? <Loader /> : <SortableTable
                    columns={metricsColumnsCustom}
                    tableData={predefinedMetricsTableData}
                    itemsPerPage={0}
                    tableId='qa-activity-metrics-predefined-table' />}
            </fieldset>
            <Popup
                isOpen={isOpenedMetricsPopUp}
                onClose={() => setIsOpenedMetricsPopUp(false)} title={<div><i className='icon-warning'></i> {genericTexts.defaultText.deletePopupTitle}</div>}
                isDisabledClickOutside={true}>
                <p> By importing the file, existing data will be overwritten. This action cannot be undone.</p>
                <div className='hidden-row'><InputRow
                    inputId='fileUpload'
                    title='Import Metrics'
                    inputType='file'
                    changeValueHandler={changeFile}
                    defaultValue={metricsFile} /></div>
                <InputRow inputId='checkbox' title='Don’t show again' inputType='checkbox' defaultValue={isWarningDisabled} changeValueHandler={setIsWarningDisabled} />

                <div className='popup-buttons'>
                    <button className='btn-submit' onClick={importMetricsClick} id='got-it'>Got It</button>
                </div>
            </Popup>
            <Popup
                isOpen={isOpenedMetricsErrorsPopup}
                onClose={() => setIsOpenedMetricsErrorsPopup(false)} title={<div><i className='icon-warning'></i> Import Warnings</div>}
                customClass='import-errors'>
                <p>Import completed with warnings. You can fix your file and upload again or fill the missed fields</p>
                {importingErrors.map((error, i) => <p key={i} className='error-msg' id={`qa-import-error-${i}`}>{error}</p>)}
                <div className='popup-buttons'>
                    <button className='btn-submit' onClick={() => setIsOpenedMetricsErrorsPopup(false)} id='import-warning-ok'>OK</button>
                </div>
            </Popup>
            <Popup
                isOpen={isOpenedSheetPopUp}
                onClose={closeSheetPopUp} title={<div className='popup-cloud-icon'><i className='icon-upload-cloud'></i></div>}>
                <div className='sheet-name-popup'>
                    <div className='sheet-file-name'><span>{metricsFile?.name || ''}</span></div>
                    <InputRow 
                        inputId='textInput' 
                        placeholder='Enter Sheet name' 
                        title='Sheet Name'
                        defaultValue={sheetName}
                        changeValueHandler={setSheetName} />
                </div>
                <div className='popup-buttons'>
                    <button className={`btn-submit ${isButtonLoading ? 'loader' : ''}`} onClick={uploadNewMetrics} id='upload-metrics'>Upload</button>
                </div>
            </Popup>
            <Popup
                isOpen={isOpenedCalculationConfirmationPopup}
                onClose={() => setIsOpenedCalculationConfirmationPopup(false)} title={<div><i className='icon-warning'></i> {genericTexts.defaultText.deletePopupTitle}</div>}
                isDisabledClickOutside={true}>
                <p>By performing calculation, existing data will be overwritten. This action cannot be undone.</p>
                <div className='popup-buttons'>
                    <button className='btn-submit' onClick={calculateMetrics} id='calc-ok'>Continue</button>
                </div>
            </Popup>
        </div>)
}


const QAActivityMetrics = connect(mapStateToProps)(QAActivityMetricsComponent)

export default QAActivityMetrics

